import { useMemo } from 'react';
import { usePersonalRoomList, useRoomListLoading } from 'shared-state/directory/hooks';
import { sortRoomList } from './helpers';

export interface IRoomListState {
    personalRoomIds: string[];
    /** Exposed so the parent can mount PersonalRoomList while rooms are loading (empty list + skeleton). */
    isPersonalRoomsLoading: boolean;
}

export const useRoomListState: () => IRoomListState = () => {
    const personalRooms = usePersonalRoomList();
    const [isPersonalRoomsLoading] = useRoomListLoading();

    const personalRoomIds = useMemo(() => {
        return sortRoomList(personalRooms).map((r: any) => r.id);
    }, [personalRooms]);

    return {
        personalRoomIds,
        isPersonalRoomsLoading
    };
};
